"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncEmitter = exports.Emitter = exports.onceEvent = exports.listenOnce = void 0;
const Disposable_1 = require("./Disposable");
const sleep_1 = require("./sleep");
/**
 * Waits for the event to fire, then resolves the promise once finished
 */
function listenOnce(event, condition) {
    return new Promise((resolve) => {
        const disposable = event((result) => {
            if (typeof condition === "undefined" || condition(result)) {
                disposable.dispose();
                resolve(result);
            }
        });
    });
}
exports.listenOnce = listenOnce;
function onceEvent(event) {
    return (listener, thisArgs) => {
        const result = event((e) => {
            result.dispose();
            return listener.call(thisArgs, e);
        });
        return result;
    };
}
exports.onceEvent = onceEvent;
class Emitter {
    registeredListeners = new Set();
    _event;
    get event() {
        if (!this._event) {
            this._event = (listener) => {
                this.registeredListeners.add(listener);
                return Disposable_1.Disposable.create(() => {
                    this.registeredListeners.delete(listener);
                });
            };
        }
        return this._event;
    }
    /** Invoke all listeners registered to this event. */
    fire(event) {
        this.registeredListeners.forEach((listener) => {
            listener(event);
        });
    }
    dispose() {
        this.registeredListeners = new Set();
    }
}
exports.Emitter = Emitter;
/**
 * Works just like Emitter, but requires the listeners to return a promise. When "fire" is called
 * it will be resolved rejected, based on calling the listeners. The constructor takes a timeout
 */
class AsyncEmitter {
    timeoutMs;
    registeredListeners = new Set();
    _event;
    constructor(timeoutMs) {
        this.timeoutMs = timeoutMs;
    }
    get event() {
        if (!this._event) {
            this._event = (listener) => {
                this.registeredListeners.add(listener);
                return Disposable_1.Disposable.create(() => {
                    this.registeredListeners.delete(listener);
                });
            };
        }
        return this._event;
    }
    /** Invoke all listeners registered to this event and wait for them to resolve, unless timeout occurs. */
    fire(event) {
        return Promise.race([
            (0, sleep_1.sleep)(this.timeoutMs).then(() => {
                throw new Error("Timeout firing async event");
            }),
            // We run all listeners in parallel, where if any fails, the firing of the event fails
            Promise.allSettled(Array.from(this.registeredListeners).map((listener) => listener(event))).then((results) => {
                for (const result of results) {
                    if (result.status === "rejected") {
                        throw result.reason;
                    }
                }
            }),
        ]);
    }
    dispose() {
        this.registeredListeners = new Set();
    }
}
exports.AsyncEmitter = AsyncEmitter;
//# sourceMappingURL=data:application/json;base64,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